import { paths } from '@/config/paths'
import { AppSidebar, Nav, NavRolesOperator } from '@/components/sidebar/sidebar'
import { Package, ShieldBan, Truck, PackageCheck, Grip, TriangleAlert, Boxes, Layers, MapPinned } from 'lucide-react'

const NAV: Nav = [
  {
    items: [
      {
        title: 'Dashboard',
        url: paths.app.dashboard.getHref(),
        Icon: Grip,
        isEnd: true,
      },
    ],
  },
  {
    items: [
      {
        title: 'Stock',
        Icon: Layers,
        items: [
          {
            title: 'Parts',
            url: paths.app.stock.parts.list.getHref(),
            color: '#ff9f29',
            roles: 'part-read',
          },
          {
            title: 'Boxes',
            url: paths.app.stock.boxes.list.getHref(),
            color: '#487fff',
            roles: 'box-read',
          },
          {
            title: 'Scraps',
            url: paths.app.stock.scraps.list.getHref(),
            color: '#ef4444',
            roles: 'part-scrap',
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: 'Packages',
        url: paths.app.allLocalPackages.getHref(),
        Icon: Boxes,
        roles: [
          'gts-package-read',
          'ship-out-read',
          'in-transit-read',
          'received-read',
          'received-read',
          'deviation-read',
          'incident-read',
        ],
        rolesOperator: NavRolesOperator.or,
      },
    ],
  },
  {
    items: [
      {
        title: 'Supplier Locations',
        url: paths.app.locations.getHref(),
        Icon: MapPinned,
        roles: 'location-write',
      },
    ],
  },
  {
    title: 'Outgoing',
    items: [
      {
        title: 'Packaging',
        url: paths.app.packaging.list.getHref(),
        Icon: Package,
        roles: 'gts-package-read',
      },
      {
        title: 'Logistics',
        url: paths.app.logistics.list.getHref(),
        Icon: Truck,
        roles: 'ship-out-read',
      },
    ],
  },
  {
    title: 'Incoming',
    items: [
      {
        title: 'Confirm arrivals',
        url: paths.app.received.list.getHref(),
        Icon: PackageCheck,
        roles: 'received-read',
      },
    ],
  },
  {
    title: 'Security',
    items: [
      {
        title: 'Deviations',
        url: paths.app.deviations.list.getHref(),
        Icon: TriangleAlert,
        roles: 'deviation-read',
      },
      {
        title: 'Incidents',
        url: paths.app.incidents.getHref(),
        Icon: ShieldBan,
        roles: 'incident-read',
      },
    ],
  },
]

export const LocalSidebar = () => {
  return <AppSidebar nav={NAV} />
}
